import { PropsWithChildren, useMemo } from 'react';

import { createTriggerStore, TriggerContext, TriggerProps } from './triggerStore';

type TriggerProviderProps = PropsWithChildren<TriggerProps>;

export const TriggerProvider = ({ children, ...props }: TriggerProviderProps) => {
  const store = useMemo(() => createTriggerStore(props), [props]);
  return <TriggerContext.Provider value={store}>{children}</TriggerContext.Provider>;
};
